import { Box, styled, Typography } from '@mui/material';
import { DeleteModalStyled, ModalContainer } from 'components/delete-modal/styles';

export const MergeModalStyled = styled(DeleteModalStyled)(({ theme }) => ({
  width: '640px',
  maxHeight: '90vh',
  [theme.breakpoints.up('sm')]: {
    width: '640px',
  },
  [theme.breakpoints.down(691)]: {
    width: '94%',
  },
}));

export const MergeModalContainer = styled(ModalContainer)(() => ({
  maxHeight: '85vh',
  overflowY: 'auto',
}));

export const MergeProposalCard = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '8px',
  padding: '12px 16px',
  marginBottom: '12px',
}));

export const MergeProposalDays = styled(Box)(() => ({
  marginLeft: '42px',
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
}));

export const MergeDayRow = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: '16px',
  fontSize: 14,
}));

export const MergeNote = styled(Typography)(({ theme }) => ({
  marginTop: '8px',
  fontSize: 13,
  color: theme.palette.text.secondary,
}));

export const MergeWarning = styled(Typography)(() => ({
  marginTop: '8px',
  marginLeft: '42px',
  fontSize: 13,
  color: '#B26A00',
}));

export const MergeProgress = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '16px',
  padding: '16px 0',
}));

export const MergeResultTitle = styled(Typography)(() => ({
  fontWeight: 600,
  fontSize: 14,
}));

export const MergeResultMessage = styled(Typography)(({ theme }) => ({
  fontSize: 13,
  marginLeft: '12px',
  color: theme.palette.text.secondary,
}));
